/**
 * Admin Document Upload Page
 *
 * Standalone page for admin document upload functionality
 */

import React from 'react';
import AdminNavbar from '../components/AdminNavbar';
import AdminDocumentUpload from '../components/AdminDocumentUpload';
import '../styles/brand.css';

const AdminDocumentUploadPage = () => {
  return (
    <>
      <AdminNavbar currentPage="document-upload" />
      <AdminDocumentUpload />
    </>
  );
};

export default AdminDocumentUploadPage;